// removed by extract-text-webpack-plugin
module.exports = {"Card":"Card---2JShL","TypeIcon":"TypeIcon---37ax-"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/customer/TimeLine/EventCard/style.styl
// module id = hYTA
// module chunks = 89